import accordion from '../components/Accordion/AccordionReducer';
import escapeHatch from '../components/EscapeHatch/EscapeHatchReducer';
import contractPage, { isApprovalPopupVisible } from '../pages/CAPage/CAPageReducer';

export const reducersGB = {
    accordion,
    escapeHatch,
    isApprovalPopupVisible,
    contractPage
};
